<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="数据参数" name="stepSelect" v-if="infoData.mapperTable">
                <div class="itemForm" v-if="infoData.mapperTable">
                    <div class="label">
                        上传的数据类型:
                    </div>
                    <div class="value">
                        {{infoData.mapperTable.name}}
                    </div>
                </div>
                <div class="itemForm">
                    <div class="label">
                        数据所属城市:
                    </div>
                    <div class="value">
                        {{infoData.citys[0]}} /  {{infoData.citys[1]}}
                    </div>
                </div>
                <div class="itemForm">
                    <div class="label">
                        数据单位:
                    </div>
                    <div class="value">
                    {{infoData.unit}}
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="文件上传" name="stepFileUpload" v-if="infoData.fileUpload">
                <div class="itemForm">
                    <div class="label">
                        文件:
                    </div>
                    <div class="value file" @click="fileDownload(infoData.fileUpload.fileName)">
                        {{infoData.fileUpload.fileName}}
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="字段映射" name="stepFieldMapping" v-if="infoData.fieldMapping">

                <div class="mapping">
                    <div class="mappingList">
                        <div class="mappingHeander">
                            <div class="mappingItem">
                                <div class="mappingName">源字段</div>
                                <div class="mappingValue">目标字段</div>
                            </div>
                        </div>
                        <div class="mappingBody">
                            <div class="mappingItem"  v-for="item in infoData.fieldMapping" :key="item.originalField">
                                <div class="mappingName">{{item.originalField}}</div>
                                <div class="mappingValue">
                                    {{item.mappedField}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
<!--            <el-tab-pane label="数据导入" name="stepImport">定时任务补偿</el-tab-pane>-->
        </el-tabs>
    </div>
</template>

<script>
    import url from "../../../../utils/UrlApi"
    export default {
        name: "stepDetail",
        props: {
            infoData: {
                type: Object,
            },
        },
        data(){
            return {
                activeName: 'stepSelect'
            }
        },
        methods:{
            fileDownload(fileName){
                let token =  localStorage.getItem('token')
                window.open(url.mapperOperationdownload+'?fileName='+fileName+'&token='+token, '_blank')
            },
        }
    }
</script>

<style scoped lang="less">
    .itemForm{
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        .label{
            width: 140px;
            color: #000;
            font-size: 14px;
        }
        .value{}
        .file{
            cursor: pointer;
            &:hover{
                color: #409EFF;
            }
        }
    }

    .mapping{
        max-height: 650px; /* 设置最大高度 */
        overflow-y: auto; /* 垂直滚动条 */

        .mappingList{
            margin-top: 10px;
            .mappingHeander{
                font-weight: bold;
                font-size: 14px;
                text-align: center;
                padding-bottom: 10px;
                border-bottom: 1px solid #ccc;
            }
            .mappingBody{
                max-height: 500px;
                overflow-y: auto;
                width: 100%;
                padding-top: 10px;
                text-align: center;
                .mappingItem{
                    &:hover{
                        background-color: #cdccc7;
                    }
                }
            }
            .mappingItem{
                display: flex;
                padding: 4px 0;

                .mappingName{
                    flex: 1;
                }
                .mappingValue{
                    flex: 1;
                }
            }
        }

    }
</style>
